<template>
	<div class="ReServiceNoPurpose">
		
		<div class="ReServiceNoPurpose-input d-flex px-0" style="align-items: center;">
			<el-select
				class="w-100 select-primary overflow-overlay"
				size="large"
				placeholder="Выбрать причину отказа"
				v-model="bufferValue"
			>
				<el-option
					v-for="(el_opt, el_index) in masNopurpose"
					class="select-primary"
					:value="el_index.nopurpose_id"
					:label="el_opt.nopurpose_text"
					:key="el_index"
				>
				</el-option>
			</el-select> 
			<base-button type="danger" class="no-border my-0" simple icon @click="bufferValue = '';">
				<i class="d-inline-block tim-icons icon-simple-remove"></i>
			</base-button>
		</div>

		{{ masNopurpose }}

	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReServiceNoPurpose',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: [String, Number],
			options:{ 
				type: Array,
				default: function(){return [];},
			},
			// settings:{
			// 	type: Object,
			// 	default(){
			// 		return mapSettings
			// 		/*{
			// 			apiKey: '7f037fcc-21f0-4c1b-ad6e-1f292ef45a2f',
			// 			lang: 'ru_RU',
			// 			coordorder: 'latlong',
			// 			version: '2.1'
			// 		}*/

			// 	},
			// },			
		},
		data () {
			return {
				ver: 1,
				masApi: [],
				masNopurpose: [],
				bufferValue: null,
				
			}
		},
		watch:{
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},
		},
		computed: {

		},
		methods: {
						
			selectNoPurpose(){
				
				this.$GVO.ApiCall('GET_SERVICES',{obj:'services' ,flt:{STATUS: 'В архиве'} })
				.then((objApi) => { 
					this.masApi_total = 0;
					// this.masApi = [];
					if(objApi.success === true){ //console.log(objApi);
						this.masApi = objApi.data;
						
						for(let i = 0; i < this.masApi.length; i++) {
							// console.log(this.masApi[i].nopurpose_text);
							if(this.masApi[i].nopurpose_text != ''){
								this.masNopurpose.push({nopurpose_id:this.masApi[i].nopurpose_id, nopurpose_text:this.masApi[i].nopurpose_text});
								
							}
						}
						// console.log(this.masNopurpose);
						if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
					}
				}).catch(errorObjApi => console.error(errorObjApi));				
			}
		},
		mounted(){
			// try{
			// 	await loadYmap(this.settings);
			// 	await ymaps.ready();
			// 	this.suggestView = new ymaps.SuggestView(this.$refs.addr.$el.querySelector('input'),{results:10});
			// 	this.suggestView.events.add('select', this.selectAddress );

			// }catch (e){
			// 	console.error(e);
			// }
			this.selectNoPurpose();
		}
	}
</script>
<style scoped>
	.ReServiceNoPurpose{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
	@media (max-width: 670px) {	
		.ReServiceNoPurpose-input {
			width: 100%;
			margin-bottom: 7px;
		}
		/*
		.form-options-group > div {
			margin-bottom: 5px;
		}
		*/
	}
</style>
